export default __webpack_public_path__ + "static/media/636.5eef5f22.png";